export class Country {
	public iso: string
	public iso3: string
	public name: string
	public currency: string

	constructor(data: {
		iso: string
		iso3: string
		name: string
		currency: string
	}) {
		this.iso = data.iso
		this.iso3 = data.iso3
		this.name = data.name
		this.currency = data.currency
	}

	static create(partial: Partial<Country>): Country {
		const defaults = {
			iso: '',
			iso3: '',
			name: '',
			currency: '',
		}

		return new Country({ ...defaults, ...partial })
	}
}
